import CommentBox from "../../../components/CommentBox/CommentBox";
import Header from "../../../components/SubtaskHeader/SubtaskHeader";
import './SubtaskScreens.css';

const AudioSubtask = ({ subtask }) => (
  <div className={`subtask-card status-${subtask?.status?.status_code?.toLowerCase()}`}>
    <Header subtask={subtask} />

    <div className="file-grid">
      {subtask?.category.map(audio => (
        <div key={audio.category_id} className="audio-card">
          <span className="icon audio" />
          <p>{audio.file_name}</p>
          <small>{audio.duration}</small>
        </div>
      ))}
    </div>

    <CommentBox subtask={subtask} />
  </div>
);

export default AudioSubtask;
